import logo from './roundrock.png';
import headerlogo from './headerlogo.png'
import './App.css';
import MintBtn from './MintBtn'
import React from 'react';
import NavBar from './NavBar';
import WhitePaper from './WhitePaper';
import { Web3Button,useContractRead,useContractWrite, useContract,useAddress,ConnectWallet,useOwnedNFTs, ThirdwebNftMedia, } from "@thirdweb-dev/react";
import { Card, CardGroup, CardText} from 'reactstrap';
import StakeContract from './StakeContract';

//0.000008669344640476 Matic =1rock
//113679.840845421884994225 rock= 1 Matic

function App() {

  const address=useAddress();//userAddress
  console.log(address)
  const polygonRockersNft="0x233788FA87C4f615f6E95FA6547C78680d568453";
  const rockErcToken="0x97f1a360C7eB33d58ab680fa1379f68EFfc2EFcB";
  const stakingContractAddress="0x08E82116B974c5122FEAe72E3A97e36bBD080c09";
  
  const {contract:polygonRockersContract }=useContract(polygonRockersNft,"PolygonRockers");
  const {contract:stakingContract}=useContract(stakingContractAddress);
  const {contract:rockContract}=useContract(rockErcToken);
  const ownedNft=useOwnedNFTs(polygonRockersContract,address)
  //const { data, isLoading } = useContractRead(stakingContract, "stake")
  const { mutateAsync: stake, isLoading } = useContractWrite(stakingContract, "stake")
  
 console.log( rockContract)
  

  return (
   
    <div className="App">
 <NavBar/>
      <header className="App-header">
      <img src={headerlogo} width='100%' height={200} alt="headerlogo" />

        <img src={logo} className="App-logo" alt="logo" />
        <div className="connect">
          <ConnectWallet dropdownPosition={{ side: 'bottom', align: 'center'}} />
        </div>
        <p>
          PolygonRockers 5000 pfp Collection
        </p>
      
        <br/>
        <div>
          <h4>5000 PolygonRockers have come to rock and ride the purple wave!
          We are a pfp collection and want to help intoduce the world to Polygon
          in a fun, rocking way! We are working on this website currently as well as
          setting up the discord to hold giveaways to the public and holders. Hop in our
          discord,join the telegram and twitter and Rock On! Just click the above tab for
          the links to everywhere! As of May 24/03 Every Mint gets 1000 $rock and 
          a daily holder reward of 2400 $rock a Rocker
          </h4>
        </div>
        <MintBtn/>
        <br/>
        <center>
 
   </center>
     </header> 
 <div style={{backgroundColor:'#282c34'}} width='100%' height={200}>
 <div>
<WhitePaper/>
</div>

</div>

</div>   
    
  );
}

export default App;
